import { SymbologyType } from "../../types/SymbologyType";

export const detectBarcodeFormat = (value: string): SymbologyType => {
  if (/^\d+$/.test(value) && value.length < 8) {
    return "INCOMPLETE";
  }
  if (/^\d{8}$/.test(value)) {
    return "ARTICLE_NUMBER";
  }
  if (/^\d{12}$/.test(value)) {
    if (isUPC(value)) {
      return "UPC";
    }
    return "FOOD_ARTICLE";
  }
  if (/^\d{13}$/.test(value)) {
    return "EAN13";
  }
  if (/^\d+$/.test(value) && value.length % 2 === 0 && value.length >= 14) {
    return "ITF";
  }
  if (value.includes("goto.ikea.com")) {
    return "DATAMATRIX";
  }
  if (value.includes("ptag-info.ikea.com")) {
    return "QR_CODE";
  }

  return "UNKNOWN";
};

// Checksum calculation according to:
// https://www.gs1.org/services/how-calculate-check-digit-manually
// - Take all the digits in odd positions, add them and multiply by three;
// - Take all the digits in even positions (except for the last one) and add to the number you got above;
// - Divide that number by 10 and take the remainder;
// - If the remainder is not 0, subtract it from 10.
// That’s it.

function isUPC(barcode: string): boolean {
  if (!/^\d{12}$/.test(barcode)) {
    return false;
  }
  const digits = barcode.split("").map(Number);
  let sumOdd = 0;
  let sumEven = 0;

  for (let i = 0; i < 11; i++) {
    if (i % 2 === 0) {
      sumOdd += digits?.[i] ?? 0;
    } else {
      sumEven += digits?.[i] ?? 0;
    }
  }

  const total = sumOdd * 3 + sumEven;
  const remainder = total % 10;
  const checkDigit = remainder === 0 ? 0 : 10 - remainder;

  return checkDigit === digits[11];
}

export const shouldRestartScan = (
  lastKeyTime: number,
  SCAN_TIMEOUT: number
): boolean => {
  const currentTime = Date.now();
  const timeSinceLastKey = currentTime - lastKeyTime;
  return timeSinceLastKey > SCAN_TIMEOUT;
};

export const isEndOfScan = (key: string): boolean => {
  return key === "Enter";
};

export const shouldAddToBuffer = (key?: string): boolean => {
  // Only add printable characters to the buffer
  return key?.length === 1;
};
